<template>
  <halo-dialog :direction="direction" :visible="visible" @cancel="cancel">
    <div class="dialog-box">
      <div class="header-wrap" @click="cancel">
        <img src="./images/close_icon.png" class="close-icon" />
      </div>
      <slot></slot>
    </div>
  </halo-dialog>
</template>

<script>
import HaloDialog from '@/components/halo-dialog';

export default {
  components: {
    HaloDialog,
  },
  props: {
    direction: {
      type: String,
      default: 'bottom',
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['cancel', 'select'],
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    select(item) {
      this.$emit('select', item);
    },
  },
};
</script>

<style lang="less" scoped>
.header-wrap {
  flex-shrink: 0;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
  .close-icon {
    width: 54px;
    height: 24px;
  }
}
.dialog-box {
  width: 100vw;
  max-height: 92vh;
  background: #ffffff;
  border-radius: 20px 20px 0px 0px;
  display: flex;
  flex-direction: column;
}
</style>
